import React, { useMemo } from "react";
import { useTranslation } from "../../langs/useTranslation";
import { Typography, Paper, Grid } from "@material-ui/core";
import useStyles from "../../styles/deviceControlStyle";

const DeviceControlSet = props => {
  const classes = useStyles();
  const {
    type,
    selectDevices,
    selectDevice,
    notAllowGroup,
    imgSrc,
    notAllowAndroid,
    notAllowWindows,
    disabled,
    numType,
    clickHandler
  } = props;
  const { t, langConf } = useTranslation("deviceControl");

  const selectDisabled = useMemo(() => {
    // debug使用强制放开所有命令
    // return false
    if (
      type === "oraUpdate" ||
      type === "cmsUpdate" ||
      type === "imageUpdate" ||
      type === "grayscaleUpdate" ||
      type === "imageGrayscaleUpdate" ||
      type === "cmsPlayer"
    ) {
      return false;
    }
    if (disabled) return true;
    if (numType === "single") {
      let isValid;
      if (notAllowAndroid) {
        if (selectDevice) {
          isValid = selectDevice.os_type === "android";
        }
      }
      if (notAllowWindows) {
        if (selectDevice) {
          isValid = selectDevice.os_type === "windows";
        }
      }
      return isValid || !selectDevice;
    } else {
      let isValid;
      if (notAllowAndroid) {
        if (selectDevices.length > 0) {
          isValid = !!selectDevices.find(a => a.os_type === "android");
        }
      }
      if (notAllowWindows) {
        if (selectDevices.length > 0) {
          isValid = !!selectDevices.find(a => a.os_type === "windows");
        }
      }
      return (
        isValid ||
        selectDevices.length === 0 ||
        (notAllowGroup && selectDevices.length > 1)
      );
    }
  }, [
    selectDevices,
    selectDevice,
    type,
    disabled,
    numType,
    notAllowAndroid,
    notAllowGroup
  ]);

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={6}
      lg={4}
      xl={4}
      className={classes.deviceControlSet}
    >
      <Paper
        elevation={0}
        onClick={e => {
          if (selectDisabled) return;
          clickHandler(e);
        }}
        className={`${classes.controlPaper} ${
          selectDisabled ? classes.notAllow : ""
        }`}
      >
        <div className={classes.controlTop}>
          <div className={classes.controlLeft}>
            {selectDisabled ? (
              <imgSrc.Gray className={classes.icon} />
            ) : (
              <imgSrc.Black className={classes.icon} />
            )}
            <div className={classes.controlTextSet}>
              <Typography variant="body1">{t(`common.${type}`, {nubis: langConf.deviceCenter?.nubisText || "Nubis", ora: langConf.deviceCenter?.oraText || "Ora"})}</Typography>
              {notAllowGroup && (
                <Typography variant="body2" color="secondary">
                  {t("common.onlyForSingle")}
                </Typography>
              )}
              {notAllowAndroid && (
                <Typography variant="body2" color="secondary">
                  {t("common.onlyForWindows")}
                </Typography>
              )}
            </div>
          </div>
        </div>
      </Paper>
    </Grid>
  );
};

export default DeviceControlSet;
